module.exports = __webpack_public_path__ + "static/media/infoiconamb.c6180797.svg";